export const shortenTimeString = (duration: number, timestamp?: string) => {
  if (!timestamp || timestamp.length < 8) return timestamp;

  return duration < 3600 ? timestamp.slice(3) : timestamp;
};
